<template>
    <div>
        <MenuWebsite/>
    </div>
</template>

<script>
    import MenuWebsite from "@/components/admin/manage_website/menu_website/MenuWebsite.vue";
    export default {
        name: "ManageMain",
        components: {
            MenuWebsite,
        }
    }
</script>

<style scoped>

</style>
